import { useEffect } from 'react'

/**
 * Hook to set the page title dynamically
 * @param title - The title to set. If not provided, uses the default title
 * @param suffix - Optional suffix to append to the title (e.g., " - Play by Noctua")
 */
export function usePageTitle(title?: string, suffix: string = ' | Play by Noctua Games') {
  useEffect(() => {
    const defaultTitle = 'Play by Noctua Web'

    if (title) {
      document.title = `${title}${suffix}`
    } else {
      document.title = defaultTitle
    }

    // Cleanup: restore default title when component unmounts
    return () => {
      document.title = defaultTitle
    }
  }, [title, suffix])
}
